import { FilterItem, filtersLibrary } from "@/components/filter/filter.types.ts";
import { ApiEmployeeLifecycleStatus } from "@/types/employees/employee.types.ts";
import { CoreFilterType, FilterRenderType, FilterValueType } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

// Конфиг общий для кнопки фильтра, выгрузки и таблицы — иначе выгрузка разойдётся с экраном.
export function usePolicyReportFilters(): FilterItem[] {
  const { t } = useTranslation();
  const library = filtersLibrary();

  return [
    library.page_number,
    library.text,
    library.employee_ids,
    library.job_profile_ids,
    library.job_role_ids,
    library.department_ids,
    library.division_ids,
    library.location_ids,
    {
      ...library.employee_lifecycle_statuses,
      defaultValue: [
        ApiEmployeeLifecycleStatus.hired,
        ApiEmployeeLifecycleStatus.employed,
        ApiEmployeeLifecycleStatus.on_leave,
        ApiEmployeeLifecycleStatus.on_parental_leave,
      ],
    },
    {
      name: "without_required_approval_only",
      type: CoreFilterType.urlParam,
      valueType: FilterValueType.boolean,
      renderType: FilterRenderType.switch,
      label: t("time_off:without_required_approval_only"),
      description: t("time_off:without_required_approval_only_description"),
    },
    {
      name: "without_policy_only",
      type: CoreFilterType.urlParam,
      valueType: FilterValueType.boolean,
      renderType: FilterRenderType.switch,
      label: t("time_off:without_policy_only"),
      description: t("time_off:without_policy_only_description"),
    },
  ];
}

export function stripEmptyArrays<T extends object>(filter: T): T {
  const result = { ...filter };
  for (const key of Object.keys(result) as (keyof T)[]) {
    const value = result[key];
    if (Array.isArray(value) && value.length === 0) {
      delete result[key];
    }
  }
  return result;
}
